import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema, IUserSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCustomUrl, getPage, getPartner, getProduct, getUser } from '../../utils/tracking';
import { getProducts } from '../../utils/tracking/get_products';

export type TTrackFirstMessageShowPopupAction = 'open_message' | 'open_phone' | 'open';

export const trackClickShowPhone = (
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  abGroup: number,
  user: IUserSchema | null,
  isBot?: boolean,
) => {
  const products = getProducts(agent, offer, null);

  ca('eventSite', {
    action: `Open_card_agent_block${isBot ? '_bot' : ''}`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    page: getPage(agent, offer),
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, abGroup),
  });
};

export const trackFirstMessageClick = (offer: IOfferSchema, agent: IAgentSchema | null) => {
  const products = getProduct(offer, agent);

  ca('event', {
    action: 'send_message',
    category: 'card',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
};

export const trackFirstMessageSent = (
  agent: IAgentSchema | null,
  offer: IOfferSchema,
  user: IUserSchema | null,
  kpId: number | null,
) => {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: 'send_message',
    category: 'Message_popup',
    label: [offer.id, user && user.realtyUserId].filter(Boolean).join('/'),
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
};

export const trackGoToMessages = () => {
  ca('event', {
    action: 'go_to_messages',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
};

export const trackFirstMessageShowPopup = (
  offer: IOfferSchema,
  agent: IAgentSchema | null,
  action: TTrackFirstMessageShowPopupAction = 'open',
) => {
  ca('event', {
    action,
    category: 'Message_popup',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
};
